import '@ali/re-utils'; // 引入 polyfill
import Context from './Context';

export default {
  version: VERSION, /* eslint no-undef: off */
  createContext: Context.create,
};
